import React, { useEffect, useState } from 'react'

import { observer } from 'mobx-react'

import HospitalHomeLayout from 'presentation/hospital/layouts/Home'
import { useStores } from 'presentation/hooks/use-stores'
import moment from 'moment-timezone'
import { toast } from 'react-toastify'
import LoadingModal from 'presentation/shared/components/LoadingModal'
import { GetSurgialOrderCounter } from 'domain/usecases/surgical-order/get-surgical-order-counter'
import { useServices } from 'presentation/hooks/use-services'

const HospitalHome = observer(() => {
  const surgicalOrderService = useServices().surgicalOrder
  const [totalizers, setTotalizers] = useState<GetSurgialOrderCounter.Model>()
  const [showLoadingModal, setShowLoadingModal] = useState<boolean>(false)

  const hospital = useStores().currentHospital?.actualHospital
  const currentFilters = useStores().currentFilters
  const crmoFilters = currentFilters.crmoFilter
  const hospitalName = hospital?.friendly_name || hospital?.name

  const getSurgicalCount = async (
    startDate: string,
    endDate: string,
    label?: string
  ) => {
    currentFilters.setCrmoFilter({
      end: endDate,
      start: startDate,
      label
    })
    setShowLoadingModal(true)
    try {
      const response = await surgicalOrderService.getSurgicalOrderCounter({
        startDate: startDate,
        endDate: endDate
      })
      setTotalizers(response)
    } catch (error) {
      toast.error('Ocorreu um erro ao tentar carregar os totalizadores')
    } finally {
      setShowLoadingModal(false)
    }
  }

  useEffect(() => {
    if (crmoFilters?.end && crmoFilters?.start) {
      getSurgicalCount(crmoFilters?.start, crmoFilters?.end, crmoFilters?.label)
    } else {
      getSurgicalCount(
        moment().utc().startOf('day').toISOString(),
        moment().utc().endOf('day').toISOString()
      )
    }
  }, [])

  return (
    <>
      <HospitalHomeLayout
        hospitalName={hospitalName}
        changeFilter={getSurgicalCount}
        counters={totalizers}
        crmoDefaultFilters={
          crmoFilters || {
            end: moment().utc().endOf('day').toISOString(),
            start: moment().utc().startOf('day').toISOString()
          }
        }
      />
      <LoadingModal show={showLoadingModal} />
    </>
  )
})

export default HospitalHome
